import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
// import { Logo, loader_image } from "../_components/Imagepath";
import { Logo } from "../_components/Imagepath";
// import $ from "jquery";

import AWS from 'aws-sdk';

import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const QualityReportsView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(447)); 
        console.log(permission);

    axios
      .get(`/quality-report/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.report);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

 

  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

  const th1 = {
    border: '2px solid #000', 
    borderLeft: '0px solid #000',  // Correct capitalization
    borderRight: '0px solid #000'  // Correct capitalization
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Quality Report</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-reports">Quality Reports  </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Quality Reports
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
            {permission && permission.list == 1 && (
                  <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">

                    <div className="row">
                      <div className="col-md-2" style={{textAlign:'center'}}>
                      <img src={Logo} alt="Logo" width="100" height="100" />
                      </div>
                      <div className="col-md-10" style={{paddingTop:"10px"}}>
                        <h2>OUTBOUND QUALITY REPORT</h2>
                        <p>Export Optimum</p>
                      </div>
                      </div>

                      <br/><br/>
                      {/* <div style={{float:"right"}}>
                        <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Download Production Output <i className="fa fa-print" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                      </div> */}
                    
                    
                          <h2 style={{color:"#709506"}}>Details: </h2>
                        
                      
                      <table className="table table-bordered">
                        <tr style={th1}>
                          <td className="p-3">Sender</td>
                          <th className="p-3">{value.sender}</th>
                          <td className="p-3">Customer</td>
                          <th className="p-3">{value.customer}</th>
                        </tr>
                        <tr style={th1}>
                          <td className="p-3">Ref</td>
                          <th className="p-3">{value.ref}</th>
                          <td className="p-3">PO</td>
                          <th className="p-3"> {value.order ? value.order_detail.po_number : ""}</th>
                        </tr>
                        <tr style={th1}>
                          <td className="p-3">Product</td>
                          <th className="p-3">{value.product}</th>
                          <td className="p-3">Transport</td>
                          <th className="p-3">{value.transport}</th>
                        </tr>
                        <tr style={th1}>
                          <td className="p-3">Date</td>
                          <th className="p-3">{value.date}</th>
                          <td className="p-3">Transpor Number</td>
                          <th className="p-3">{value.transport_number}</th>
                    
                        </tr>
                      


                  
                      </table>
                      <br /> <br /> <br />
                      <h3 className="card-title">Quality Control Report</h3>
                      <div className="row">
                      <div className="col-md-10">
                      <table className="table table-bordered">
                            <tr>
                                <th className="p-3">{'PO'}</th>
                                <th className="p-3">{'Ref'}</th>
                                <th className="p-3">Customer</th>
                                <th className="p-3">{'Loading date'}</th>
                              </tr>
                              <tr>
                                <th className="p-3"> {value.order ? value.order_detail.po_number : ""}</th>
                                <th className="p-3">{value.ref}</th>
                                <th className="p-3">{value.customer}</th>
                                <th className="p-3">{value.date}</th>
                              </tr>
                      </table>

                      </div>
                      <div className="col-md-2">
                      <img src={Logo} alt="Logo" width="100" height="100" />
                      </div>
                      </div>
                      <br /> <br /> <br />
                      

                      <table className="table table-bordered">
                        

                        {value.items &&
                          value.items.map((item ,palletIndex)  => (
                            <tbody  key={item.product || palletIndex}>
                                <tr >
                                <td colSpan={4}><h3  style={{color:"#709506"}}>Pallet# {palletIndex + 1}</h3></td>
                                
                              </tr>

                              <tr>
                                <td className="p-3">{'Product/Variety'}</td>
                                <th className="p-3">{item.product}</th>
                                <td className="p-3">Temperature °</td>
                                <th className="p-3">{item.temperature}</th>
                              </tr>
                              <tr>
                                <td className="p-3">{'Size'}</td>
                                <th className="p-3">{item.size}</th> 
                                <td className="p-3">Sample weight (G) </td>
                                <th className="p-3">{item.sample_weight}(G)</th>
                              </tr>
                              <tr>
                                <td className="p-3">{'Class'}</td>
                                <th className="p-3">{item.class}</th>
                                <td className="p-3">Box Net Weight (G) </td>
                                <th className="p-3">{item.box_net_weight}(G)</th>
                              </tr>
                            
                              <tr>
                                <td className="p-3">{'Packaging'}</td>
                                <th className="p-3">{item.packaging}</th>
                                <td className="p-3">Lot number </td>
                                <th className="p-3">{item.lot_number}</th>
                              </tr>
                              <tr>
                                <td className="p-3">{'Number of boxes '}</td>
                                <th className="p-3">{item.number_of_boxes}</th>
                                <td className="p-3">Palletesation </td>
                                <th className="p-3">{item.palletesation}</th>
                              </tr>
                              <tr>
                                <td className="p-3">{'Pallet barcode number'}</td>
                                <th className="p-3">{item.pallet_barcode}</th>
                                <td className="p-3">  </td>
                                <th className="p-3">{''}</th>
                              </tr>
                              <tr>
                                <td className="p-3">{'Country of origin'}</td>
                                <th className="p-3">{item.country}</th>
                                <td className="p-3">Label conformity  </td>
                                <th className="p-3">{item.label_conformity}</th>
                              </tr>
                              <tr>
                                <td colSpan={4}><h3  style={{color:"#709506"}}>Pictures#</h3></td>
                                
                              </tr>
                              <tr>
                                <th className="p-3">{item.images[0] && item.images[0].image && ( <img style={{width:'246px'}} src={viewFile(item.images[0].image) }/>)} </th>
                                <th className="p-3">{item.images[1] && item.images[1].image && ( <img style={{width:'246px'}} src={viewFile(item.images[1].image) }/>)} </th>
                                <th className="p-3">{item.images[2] && item.images[2].image && ( <img style={{width:'246px'}} src={viewFile(item.images[2].image) }/>)} </th>
                                <th className="p-3">{item.images[3] && item.images[3].image && ( <img style={{width:'246px'}} src={viewFile(item.images[3].image) }/>)} </th>
                              </tr>
                              <tr>
                                <th className="p-3">{item.images[4] && item.images[4].image && ( <img style={{width:'246px'}} src={viewFile(item.images[4].image) }/>)} </th>
                                <th className="p-3">{item.images[5] && item.images[5].image && ( <img style={{width:'246px'}} src={viewFile(item.images[5].image) }/>)} </th>
                              </tr>
                              
                            </tbody>
                            
                          ))}
                      </table>
                    </div>
                  </div>
                  </div>
                  )}
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityReportsView;
